import tw, { styled } from 'twin.macro';

const Logo = styled.img`
  ${tw`mr-4`}
  max-width: 100px;
  max-height: 40px;
`;

export default Logo;
